/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingChangeStatusEnum } from './BookingChangeStatusEnum';
import {
    BookingChangeStatusEnumFromJSON,
    BookingChangeStatusEnumFromJSONTyped,
    BookingChangeStatusEnumToJSON,
    BookingChangeStatusEnumToJSONTyped,
} from './BookingChangeStatusEnum';

/**
 *
 * @export
 * @interface BookingChange
 */
export interface BookingChange {
    /**
     *
     * @type {string}
     * @memberof BookingChange
     */
    readonly id: string;
    /**
     *
     * @type {number}
     * @memberof BookingChange
     */
    requestedByTeam: number;
    /**
     *
     * @type {any}
     * @memberof BookingChange
     */
    changes?: any | null;
    /**
     *
     * @type {number}
     * @memberof BookingChange
     */
    baseRevision: number;
    /**
     *
     * @type {BookingChangeStatusEnum}
     * @memberof BookingChange
     */
    status?: BookingChangeStatusEnum;
    /**
     *
     * @type {string}
     * @memberof BookingChange
     */
    decisionNote?: string;
    /**
     *
     * @type {Date}
     * @memberof BookingChange
     */
    readonly createdAt: Date;
    /**
     *
     * @type {Date}
     * @memberof BookingChange
     */
    decidedAt?: Date | null;
}



/**
 * Check if a given object implements the BookingChange interface.
 */
export function instanceOfBookingChange(value: object): value is BookingChange {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('requestedByTeam' in value) || value['requestedByTeam'] === undefined) return false;
    if (!('baseRevision' in value) || value['baseRevision'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function BookingChangeFromJSON(json: any): BookingChange {
    return BookingChangeFromJSONTyped(json, false);
}

export function BookingChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingChange {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'requestedByTeam': json['requested_by_team'],
        'changes': json['changes'] == null ? undefined : json['changes'],
        'baseRevision': json['base_revision'],
        'status': json['status'] == null ? undefined : BookingChangeStatusEnumFromJSON(json['status']),
        'decisionNote': json['decision_note'] == null ? undefined : json['decision_note'],
        'createdAt': (new Date(json['created_at'])),
        'decidedAt': json['decided_at'] == null ? undefined : (new Date(json['decided_at'])),
    };
}

  export function BookingChangeToJSON(json: any): BookingChange {
      return BookingChangeToJSONTyped(json, false);
  }

  export function BookingChangeToJSONTyped(value?: Omit<BookingChange, 'id'|'created_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'requested_by_team': value['requestedByTeam'],
        'changes': value['changes'],
        'base_revision': value['baseRevision'],
        'status': BookingChangeStatusEnumToJSON(value['status']),
        'decision_note': value['decisionNote'],
        'decided_at': value['decidedAt'] == null ? undefined : ((value['decidedAt'] as any).toISOString()),
    };
}
